module.exports = __webpack_public_path__ + "static/media/error_404_img.4491d515.svg";